import type { ContentfulNavQuickLinkFragment } from '@/graphql/contentful/api';

import { useHandleQuickLink } from '../NavQuickLinkItem/helpers';

import * as S from './NavQuickLinkStoriesItem.styles';
export interface NavQuickLinkStoriesItemProps extends ContentfulNavQuickLinkFragment {
  className?: string;
  isSwiperActive?: boolean;
}

export const NavQuickLinkStoriesItem = ({
  backgroundColor,
  className,
  disableNavigationScrollToTop,
  isSwiperActive = false,
  media,
  topLabelText,
  url,
  urlTarget,
  urlText,
  urlTrigger,
}: NavQuickLinkStoriesItemProps) => {
  const { handleQuickLink } = useHandleQuickLink(
    url ?? '/',
    urlTarget ?? '_self',
    urlTrigger,
    disableNavigationScrollToTop,
  );
  return (
    <S.Wrapper
      $isActive={isSwiperActive}
      className={className}
      data-testid='NavQuickLinkStoriesItemWrapper'
      onClick={handleQuickLink}
    >
      <S.TopLabel
        $backgroundColor={backgroundColor as string}
        data-testid='NavQuickLinkStoriesItemLabel'
      >
        {topLabelText}
      </S.TopLabel>
      {media && (
        <S.NavQuickImgBox data-test-id='NavQuickLinkStoriesItemNavQuickImgBox'>
          <S.NavQuickImg
            alt={media.title ?? ''}
            aria-hidden
            className={className}
            data-testid='NavQuickLinkStoriesItemNavQuickImg'
            fill
            height={0}
            loaderHeight={350}
            loading='eager'
            sizes='50vw'
            src={media.url ?? ''}
            width={0}
          />
        </S.NavQuickImgBox>
      )}
      <S.Label
        $isActive={isSwiperActive}
        data-testid='NavQuickLinkStoriesItemLabel'
      >
        {urlText}
      </S.Label>
    </S.Wrapper>
  );
};
